import Main from './001.png';
import PlayBtn from './002.png';
import News from './003.png';
import Award from './004.png';
import Help from './005.png';
import Focus from './006.png';
import Contact from './007.png';
import Trigger from './008.png';
import NewsText from './009.png';
import Footer from './010.png';
import Logo from './logo.jpeg';

export const sectionImages = {
  Main,
  PlayBtn,
  News,
  Award,
  Help,
  Focus,
  Contact,
  Trigger,
  NewsText,
  Logo,
  Footer,
};
